import React from 'react';
import { useSelector } from 'react-redux';
import {
  SharedTemplateAboutModal,
  SharedTemplateDeleteModal,
  SharedTemplateDuplicateModal,
  SharedTemplateEditModal,
  SharedTemplateSaveModal,
  SharedTemplateShareModal,
  SharedTemplateTriOptionModal,
  SharedTemplateUnsavedModal,
} from '../presentational/sharedTemplateComponents';
import SCLegendInfoModal from '../../../sport-coach-dashboard/components/presentational/SCLegendInfoModal';

const KPITrackerTemplateModals = () => {
  const scAboutModalShowing = useSelector(
    (state) => state.sportCoachDashboard.ui.aboutDashboardModalShowing,
  );
  const scDeleteModalShowing = useSelector(
    (state) => state.sportCoachDashboard.ui.deleteDashboardModalShowing,
  );
  const scDuplicateModalShowing = useSelector(
    (state) => state.sportCoachDashboard.ui.duplicateDashboardModalShowing,
  );
  const scEditModalShowing = useSelector(
    (state) => state.sportCoachDashboard.ui.editDashboardModalShowing,
  );
  const scSaveModalShowing = useSelector(
    (state) => state.sportCoachDashboard.ui.saveDashboardModalShowing,
  );
  const scShareModalShowing = useSelector(
    (state) => state.sportCoachDashboard.ui.isShareDashModalShowing,
  );
  const scTriOptionModalShowing = useSelector(
    (state) => state.sportCoachDashboard.ui.triOptionModalShowing,
  );
  const unsavedSCDashModalShowing = useSelector(
    (state) => state.sportCoachDashboard.ui.isUnsavedDashModalShowing,
  );
  const isLegendInfoModalShowing = useSelector(
    (state) => state.sportCoachDashboard.ui.isLegendInfoModalShowing,
  );

  return (
    <>
      {scAboutModalShowing && (
        <SharedTemplateAboutModal dashboard='KPI Tracker' />
      )}
      {scDeleteModalShowing && (
        <SharedTemplateDeleteModal
          dashboard='KPI Tracker'
          legacyName='Sport Coach'
        />
      )}
      {scDuplicateModalShowing && (
        <SharedTemplateDuplicateModal
          dashboard='KPI Tracker'
          legacyName='Sport Coach'
        />
      )}
      {scEditModalShowing && (
        <SharedTemplateEditModal
          dashboard='KPI Tracker'
          legacyName='Sport Coach'
        />
      )}
      {scSaveModalShowing && (
        <SharedTemplateSaveModal
          dashboard='KPI Tracker'
          legacyName='Sport Coach'
        />
      )}
      {isLegendInfoModalShowing && <SCLegendInfoModal />}
      {scShareModalShowing && (
        <SharedTemplateShareModal
          dashboard='KPI Tracker'
          legacyName='Sport Coach'
        />
      )}
      {scTriOptionModalShowing && (
        <SharedTemplateTriOptionModal
          dashboard='KPI Tracker'
          legacyName='Sport Coach'
        />
      )}
      {unsavedSCDashModalShowing && (
        <SharedTemplateUnsavedModal
          dashboard='KPI Tracker'
          legacyName='Sport Coach'
        />
      )}
    </>
  );
};

export default KPITrackerTemplateModals;
